// apps/console/src/hooks/roster-timing.ts
//
// The roster's polling cadence, on its own so that presence logic can reason about it.
//
// It lived in `useRobotsRoster.ts`, which almost every roster-facing spec replaces wholesale with
// `vi.mock('@/hooks/useRobotsRoster')`. Anything importing the constant from there got `undefined`
// under those mocks — and `undefined` inside an arithmetic window makes it `NaN`, which silently
// reports every device as offline. A module with no behaviour to stub is never mocked.

/**
 * How often the roster re-reads `GET /robots`.
 *
 * Without this the list was fetched once at mount and never again: a robot that went offline while
 * you watched kept its green dot forever, and one that came back never got one. Mirrors the CCTV
 * relay-agent precedent, whose 15s poll exists for exactly this reason.
 *
 * It is also a LATENCY: whatever the roster shows is up to this long out of date, which any
 * freshness window judged against `lastSeenAt` has to allow for (`onlineWindowMs`).
 */
export const ROSTER_REFETCH_MS = 15_000
